module.exports = __webpack_public_path__ + "76ff5ef06ade7799f1b256e273de97a5.mp4";